import { Modal } from '~/components/modal/modal-old';
import Loading from '~/components/misc/loading';
import useTranslations from '~/components/translation/use-translations';
import { WE_SPIN_MODALS_TEXT_KEYS } from '../../constants/we-spin-text-keys';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { authenticationSelector } from '~/components/authentication/ducks/selectors';
import useLoginFlow from '~/hooks/use-login-flow';
import { spectatorUnregister } from '../../ducks/we-spin-duck';
import BinaryQuestion from '~/components/binary-question';

/**
 * Modal for unregistering from a free spin event.
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.isOpen - Whether the unregister modal is open.
 * @param {Function} props.close - Function to close the unregister modal.
 * @param {string} props.streamRef - Unique reference ID for the stream.
 * @returns {JSX.Element}
 */
const UnregisterFreespinModal = props => {
	const dispatch = useDispatch();
	const location = useLocation();
	const authenticated = useSelector(authenticationSelector);
	const { initializeLogin } = useLoginFlow();
	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_MODALS_TEXT_KEYS);

	const [submitting, setSubmitting] = useState(false);

	const unregister = useCallback(async () => {
		if (!authenticated) {
			initializeLogin({
				from: `${location.pathname}${location.search}`
			});
			return;
		}

		try {
			setSubmitting(true);
			await dispatch(spectatorUnregister(props.streamRef));
			props.close();
		} finally {
			setSubmitting(false);
		}
	}, [authenticated, dispatch, initializeLogin, location.pathname, location.search, props]);

	if (isLoadingTranslations) return <Loading />;

	return (
		<Modal show={props.isOpen} position="fixed">
			<BinaryQuestion
				shouldOpenBinary
				openInSidebar
				buttonsHasUncontrolledLoading={submitting}
				title="Unregister"
				text="Are you sure you want to leave this event?"
				yesText={tr.WE_SPIN_BUY_IN_CONFIRM_BUTTON}
				noText={tr.WE_SPIN_BUY_IN_CONFIRM_CANCEL_BUTTON}
				onYesClick={unregister}
				onNoClick={props.close}
			/>
		</Modal>
	);
};

export default UnregisterFreespinModal;
